// デモのWBSデータ（wbs-items.ts の REQUIREMENTS_PHASE_ITEMS）は日付を
// 「day 0（2026-04-01、水曜日）からの経過日数」で持つ。開くたびに常に
// 直近の日付でデモが見えるよう、day 0 を「今日を含む週のうち、
// day 0 と同じ曜日（水曜日）の日」に固定してマッピングする。
// こうすることで、曜日に紐づくデータ（例: 火曜開催の会議）が
// 週末にずれることなく、元の曜日パターンのまま表示される。
const MS_PER_DAY = 24 * 60 * 60 * 1000
const DAY_ZERO_WEEKDAY = 3 // 水曜日（0 = 日曜日）
const demoScheduleRootMs = (() => {
  const today = new Date()
  const todayUtc = new Date(
    Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
  )
  const weekdayDiff = (todayUtc.getUTCDay() - DAY_ZERO_WEEKDAY + 7) % 7
  return todayUtc.getTime() - weekdayDiff * MS_PER_DAY
})()

export const dayOffsetToDate = (dayOffset: number) => {
  const date = new Date(demoScheduleRootMs + dayOffset * MS_PER_DAY)
  return date.toISOString().slice(0, 10)
}

// デモモードでは実際のアイコンCDN（FLAGXS_GLOBAL_IMAGE_BASE_URL）に
// 疎通できないため、SVGをdata URIとしてインラインで埋め込む。
export const svgDataUri = (svg: string): string =>
  `data:image/svg+xml,${encodeURIComponent(svg)}`

export const applyDelta = <T>(
  currentValue: T,
  delta?: { oldValue?: T; newValue?: T }
): T => (delta ? (delta.newValue as T) : currentValue)

export const FUNCTIONAL_API_URL = 'http://localhost:8091'
export const PRESENTATIONAL_API_URL = 'http://localhost:8093'
